import React from 'react'
import { AppPhoneInputProps, Form, FormItemProps, Input, PhoneInput, PhoneInputValue } from '@commutifi-fe/ui'
import { Overwrite } from 'utility-types'
import { useComponentIntl } from '../../../locales'

type InputProps = Overwrite<
  React.ComponentProps<typeof Input>,
  {
    // To facilitate the initialization of a phone number Field we have an object for the phone number.
    // But, when calling onChange on a regular input for the phone number, we will get a string back.
    value?: (PhoneInputValue & { ext?: string }) | string
  }
>
export interface PhoneNumberFormItemProps extends FormItemProps {
  initialValue?: AppPhoneInputProps['value'] & { ext?: string }
  inputProps?: InputProps
}

export function PhoneField({ value, ...props }: InputProps) {
  return (
    <Input
      type="tel"
      placeholder="(444) 123 4567"
      value={typeof value === 'string' ? value : value?.phone}
      {...props}
    />
  )
}

/**
 * IMPORTANT: this component can only be used in and ant design Form component
 */
export function PhoneNumberFormItem({ children, label, inputProps, ...otherFormItemProps }: PhoneNumberFormItemProps) {
  const intl = useComponentIntl('phone')
  return (
    <Form.Item
      label={label ?? intl.formatMessage({ id: 'label.phoneNumber' })}
      name="phoneNumber"
      validateTrigger={['onChange', 'onBlur']}
      {...otherFormItemProps}
    >
      {children || <PhoneField {...inputProps} />}
    </Form.Item>
  )
}

PhoneNumberFormItem.TelInput = PhoneInput
PhoneNumberFormItem.Input = PhoneField

export default PhoneNumberFormItem
